import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function Mechanism() {
  const steps = [{
    level: 1,
    title: 'Cero presión',
    desc: 'Reiniciar el clima para que el cuerpo deje de anticipar exigencia'
  }, {
    level: 2,
    title: 'Contacto seguro',
    desc: "Tocar sin que 'signifique más'"
  }, {
    level: 3,
    title: 'Juego',
    desc: 'Ligereza real: curiosidad sin expectativa'
  }, {
    level: 4,
    title: 'Deseo',
    desc: "Invitar claro + salida segura para que el 'no' no rompa nada"
  }, {
    level: 5,
    title: 'Sexualidad',
    desc: 'Acuerdos + aftercare para que se vuelva repetible'
  }];
  return <Section dark className="relative overflow-hidden" data-id="element-93">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-94">
        <div className="absolute right-0 top-0 w-64 h-64 bg-[#C4A35A] rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-95"></div>
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-[#C4A35A] rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-96"></div>
      </div>

      <div className="text-center mb-16 relative z-10" data-id="element-97">
        <span className="text-[#C4A35A] font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-98">
          El Método
        </span>
        <h2 className="text-3xl md:text-5xl font-serif text-[#2D2A26] mb-6" data-id="element-99">
          La solución: reconstruir por niveles
        </h2>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-100">
          Intimidad Sin Presión es un PDF práctico para parejas largas que se
          quieren, pero están desconectadas. Te guía con{' '}
          <span className="font-semibold text-[#C4A35A]" data-id="element-101">
            La Escalera de Cercanía
          </span>
          :
        </p>
      </div>

      <div className="relative max-w-2xl mx-auto z-10" data-id="element-102">
        {/* Vertical line connecting steps */}
        <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-[#C4A35A]/30 hidden md:block" data-id="element-103"></div>

        <div className="space-y-6" data-id="element-104">
          {steps.map((step, index) => <motion.div key={step.level} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 bg-white p-6 rounded-sm shadow-sm relative" data-id="element-105">
              <div className="flex-shrink-0 w-16 h-16 rounded-full bg-[#FAF7F2] border-2 border-[#C4A35A] flex items-center justify-center text-2xl font-serif font-bold text-[#C4A35A] z-10" data-id="element-106">
                {step.level}
              </div>
              <div data-id="element-107">
                <h3 className="text-xl font-serif font-bold text-[#2D2A26] mb-1" data-id="element-108">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-109">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>

      <div className="mt-16 text-center relative z-10" data-id="element-110">
        <p className="text-xl font-serif italic text-[#2D2A26]" data-id="element-111">
          "No es un libro para 'encender la chispa'.{' '}
          <br className="hidden md:block" data-id="element-112" />
          Es un sistema para que la chispa deje de sentirse peligrosa."
        </p>
      </div>
    </Section>;
}